import { useRealtimeStore } from '../model/realtime.store'

/**
 * Hook to get realtime orders from the store
 */
export function useRealtimeOrders() {
  return useRealtimeStore(state => state.realtimeOrders)
}

/**
 * Hook to check if realtime should be used for all data types
 */
export function useRealtimeEnabled() {
  return useRealtimeStore(state => state.useRealtime)
}

/**
 * Hook to get realtime wait time data
 */
export function useRealtimeWaitTimeData() {
  return useRealtimeStore(state => state.realtimeWaitTime)
}

/**
 * Hook to get realtime wait time data with enabled state
 * Returns { data, enabled } for wait time realtime state
 */
export function useRealtimeWaitTime() {
  const data = useRealtimeWaitTimeData()
  const enabled = useRealtimeEnabled()

  return { data, enabled }
}

/**
 * Hook to get realtime connection status
 */
export function useRealtimeConnectionStatus() {
  return useRealtimeStore(state => state.isConnected)
}

/**
 * Hook to get last realtime event
 */
export function useRealtimeLastEventTime() {
  return useRealtimeStore(state => state.lastRealtimeEventTime)
}

/**
 * Hook to get the full realtime state (use sparingly)
 */
export function useRealtimeState() {
  return useRealtimeStore()
}
